"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseCommand = void 0;
const clipanion_1 = require("clipanion");
const t = __importStar(require("typanion"));
const constants_1 = require("./constants");
const logger_1 = require("./helpers/logger");
/**
 * This command should be extended by **every** command in the monorepo.
 */
class BaseCommand extends clipanion_1.Command {
    constructor() {
        super(...arguments);
        // Hidden while the JSON logging migration is in progress: most commands do not
        // honour it yet. Unhide once coverage is broad enough.
        // Resolution order (handled by clipanion): CLI flag > DD_LOG_FORMAT env var > default.
        this.logFormat = clipanion_1.Option.String('--log-format', 'text', {
            env: constants_1.LOG_FORMAT_ENV_VAR,
            hidden: true,
            description: "Output format for logs: 'text' (default) or 'json' (one JSON object per line).",
            validator: t.isEnum(['text', 'json']),
        });
    }
    get logger() {
        if (!this._logger) {
            // The sanctioned sink: this is the single place allowed to write to the raw stream.
            // eslint-disable-next-line no-restricted-syntax
            this._logger = new logger_1.Logger((s) => this.context.stdout.write(s), logger_1.LogLevel.INFO, {
                jsonOutput: this.logFormat === 'json',
            });
        }
        return this._logger;
    }
}
exports.BaseCommand = BaseCommand;
//# sourceMappingURL=index.js.map